class MegaMenu {
  constructor(menuWrapper) {
    const toggleElement = menuWrapper.querySelector('.has-mega-dropdown');
    const listElement = menuWrapper.querySelector('.mega-dropdown');
    const timeoutLength = 250;
    let enterTimeout;
    let leaveTimeout;

    function showList() {
      clearTimeout(leaveTimeout);

      enterTimeout = setTimeout(() => {
        menuWrapper.classList.add('is-expanded');
        toggleElement.setAttribute('aria-expanded', 'true');
        toggleElement.setAttribute('aria-expanded', 'true');
        listElement.setAttribute('aria-hidden', 'false');
      }, timeoutLength);
    }

    function hideList() {
      clearTimeout(enterTimeout);

      leaveTimeout = setTimeout(() => {
        menuWrapper.classList.remove('is-expanded');
        toggleElement.setAttribute('aria-expanded', 'false');
        toggleElement.setAttribute('aria-expanded', 'false');
        listElement.setAttribute('aria-hidden', 'true');
      }, timeoutLength);
    }

    if (menuWrapper) {
      menuWrapper.addEventListener('focusin', () => showList());
      menuWrapper.addEventListener('focusout', () => hideList());
      menuWrapper.addEventListener('mouseenter', () => showList());
      menuWrapper.addEventListener('mouseleave', () => hideList());
    }
  }
}

export default MegaMenu;
